import { PropertyMetaData } from './property-meta-data';

export class ModelVersionMetaData extends PropertyMetaData {

    protected override _type = 'ModelVersion';
}
